import { Dispatch } from 'redux'

import * as Api from 'redux/api/AdditionalSegments'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryCreateAdditionalSegmentBy(body: {
  widget_id: string
  attribute_option_id: string
}) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    Api.create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.createFailed())
      })
  }
}

export function tryUpdateAdditionalSegmentBy(
  id: string,
  body: {
    attribute_option_id: string
  }
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    Api.update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.updateFailed())
      })
  }
}

export function tryDeleteAdditionalSegmentBy(id: string, widgetId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    Api.destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess({ id, widgetId }))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())
      })
  }
}

export const useAdditionalSegmentActions = () => {
  return {
    tryCreateAdditionalSegmentBy: useThunkActions(tryCreateAdditionalSegmentBy),
    tryUpdateAdditionalSegmentBy: useThunkActions(tryUpdateAdditionalSegmentBy),
    tryDeleteAdditionalSegmentBy: useThunkActions(tryDeleteAdditionalSegmentBy)
  }
}
